import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "raf",
  name: "Raf",
  tagline: "Rafları düzenle: üç aynı ya da aynı gruptan üç farklı resim.",
  inspiredBy: "Sort Express / Goods Sort / Match Factory (raf ayıklama)",
  secondLayer: "Bilgi: 6. bölümden sonra aynı gruptan (meyve, memeli, Avrupa bayrağı...) üç farklı resim de üçlü sayılır.",
  accent: "#ff924c",
  status: "lab",
};
